<h1 mat-dialog-title class="dialog-title">Automatisch plannen</h1>

<div class="dialog-container" mat-dialog-content>
  <div class="dialog-content">
    @if (!loading() && !result()) {
      <p class="dialog-description">
        Weet u zeker dat u het automatisch plannen wilt starten voor
        <b>{{ moment(data.date).format('DD MMMM YYYY') }}</b
        >?
      </p>

      <div class="info-section">
        <p class="info-text">
          De ritten die automatisch kunnen worden ingepland, worden toegevoegd aan het planningsoverzicht.
        </p>

        <p class="info-text">Ritten die niet ingepland kunnen worden, blijven zichtbaar als restritten.</p>
      </div>
    }
    @if (!loading() && result(); as autoPlanResult) {
      <div class="info-section">
        @if (
          autoPlanResult.status === 'success' ||
          autoPlanResult.status === 'no_generated_routes' ||
          autoPlanResult.status === 'no_compatible_rides'
        ) {
          <p class="info-text">
            Het automatisch plannen van de ritten op <b>{{ moment(data.date).format('DD MMMM YYYY') }}</b> is afgerond.
            Er zijn <b>{{ autoPlanResult.unassignedRides }} restritten</b>.
          </p>
        }
        @if (autoPlanResult.status === 'no_rides_to_plan') {
          <p class="info-text">
            Er zijn op <b>{{ moment(data.date).format('DD MMMM YYYY') }}</b> geen ritten om automatisch in te plannen.
          </p>
        }
        @if (autoPlanResult.status === 'no_vehicles_to_plan') {
          <p class="info-text">
            Er zijn op <b>{{ moment(data.date).format('DD MMMM YYYY') }}</b> geen voertuigen beschikbaar waardoor er
            geen ritten gepland kunnen worden.
          </p>
        }
      </div>
    }
    @if (loading()) {
      <mat-spinner diameter="20"></mat-spinner>
      <span>Bezig met plannen...</span>
    }
  </div>

  <div mat-dialog-actions class="dialog-actions">
    @if (!result()) {
      <button mat-button class="cancel-button" (click)="dialogRef.close(false)" [disabled]="loading()">
        Annuleren
      </button>

      <button
        mat-flat-button
        class="primary-color confirm-button"
        (click)="planAutomaticRides()"
        [disabled]="loading()"
      >
        <span>Start automatisch plannen</span>
      </button>
    }
    @if (result()) {
      <button mat-flat-button class="primary-color confirm-button" (click)="dialogRef.close(true)">
        <span>Sluiten</span>
      </button>
    }
  </div>
</div>
